import "@tldraw/tldraw/tldraw.css"
import { Tldraw, TLEditorComponents } from "@tldraw/tldraw";
import { uiOverrides } from './ui-overrides.ts';
import { createClient } from "@supabase/supabase-js";
import SavePng from '../components/SavePng.js';
import Gif from '../components/Gif.js';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faArrowRight, faBorderStyle } from '@fortawesome/free-solid-svg-icons';
import logo from "../assets/logo.png";

const projectURL = "https://bzadugmbzathrddoggvu.supabase.co";
const anonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6YWR1Z21iemF0aHJkZG9nZ3Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAzMjQzNDQsImV4cCI6MjAxNTkwMDM0NH0.wrEDO90ljV4DQQioqrf9fffTv2nY82iXb537L82e-Zk";
const supabase = createClient(projectURL, anonKey);

// A function that downloads the desired amount of sketches, from newest to oldest
const downloadLatestSketches = async (amount) => {
  var sketches = [];
  const { data, error } = await supabase
  .storage
  .from('sketches')
  .list("", {
      limit: amount,
      sortBy: { column: 'created_at', order: 'desc' }
  });
  if (error) {
      throw error
  }
  for (let index = amount - 1; index >= 0; index--) {
      var fileName = data[index].name;
      var publicURL = "https://bzadugmbzathrddoggvu.supabase.co/storage/v1/object/public/sketches/" + fileName;
      sketches.push(publicURL);
  }

  return sketches;
}

const sketches = await downloadLatestSketches(3);


function CadavreExquis() {

  const [isOnionSkinVisible, setOnionSkinVisibility] = useState(true);

  const OnionSkin = () => {
    return (
      <div id="onion-skin" style={{display: isOnionSkinVisible ? "block" : "none"}}>
        <img className="onion-skin onion-skin-1" src={sketches[2]}></img>
        <img className="onion-skin onion-skin-2" src={sketches[1]}></img>
        <img className="onion-skin onion-skin-3" src={sketches[0]}></img>
      </div>
    )
  }

  const components = {
    Background: OnionSkin
  }

  const handleMount = (editor) => {
    // Freeze the camera and turn off debug mode
    editor.updateInstanceState({
      canMoveCamera: false,
      isDebugMode: false
    });
    // Allow scroll
    const drawCanvas = document.getElementById("canvas");
    drawCanvas.addEventListener("wheel", (event) => {
      window.scrollBy(0, event.deltaY);
      event.preventDefault();
    })
    //window.scrollTo(0, 0);
  }

  return (
    <div id="app">
      <a href="/"><img src={logo} alt="Cadavre Exquis" className="logo index"></img></a>
        <div id="frames">
          <p>Watch the latest three frames of the animation:</p>
          <Gif sketches={sketches}/>
        </div>
        <div id="draw">
          <p>Now, draw the next frame:</p>
          <div id="canvas">
            <Tldraw autoFocus={false} persistenceKey="canvas" onMount={handleMount} overrides={uiOverrides} components={components}>
              <SavePng supabase={supabase} />
            </Tldraw>
          </div>
        </div>
        <div id="buttons">
          <div
          id="onion-skin-toggle"
          className={isOnionSkinVisible ? "button onion-skin-on" : "button onion-skin-off"}
          onClick={() => {setOnionSkinVisibility(!isOnionSkinVisible)}}>
            <FontAwesomeIcon icon={faLayerGroup} style={{marginRight: 8}} />
            {isOnionSkinVisible ? "Hide" : "Show"} onion skin
          </div>
          <div
          id="submit-button"
          className="button"
          onClick={() => {document.getElementById("save-png").click()}}>
            Submit <FontAwesomeIcon icon={faArrowRight} className="right-arrow" />
          </div>
          </div>
    </div>
  )
}

export default CadavreExquis